import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Redirect,
} from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

import * as authActions from '../actions';
import Layout from '../../main/components/Layout';
import Alert from '../../common/components/Alert';
import SocialLoginButtons from '../components/SocialLoginButtons';
import classes from '../../css/getCSS';

class ConnectSocialAuth extends Component {
  componentDidMount() {
    document.title = 'Connect social account';
  }

  responseGoogle = (response) => {
    this.props.doSocialLogin(
      'google-oauth2',
      response,
      this.props.site.id,
      this.props.token,
    );
  }

  responseFacebook = (response) => {
    this.props.doSocialLogin(
      'facebook',
      response,
      this.props.site.id,
      this.props.token,
    );
  }

  logout = () => {
    this.props.logout(this.props.token);
  }

  render() {
    if (this.props.user.has_social_login) {
      return <Redirect to="/" />;
    }

    let error = null;

    let buttons = (
      <SocialLoginButtons
        responseGoogle={this.responseGoogle}
        responseFacebook={this.responseFacebook}
      />
    );

    if (this.props.loading) {
      buttons = (
        <div align="center">
          <CircularProgress align="center" size={50} />
        </div>
      );
    }

    if (this.props.hasError) {
      error = <Alert type="danger">An error occured while trying to login in</Alert>;
    }

    return (
      <Layout hideNavbar rootClass={[classes.loginBack].join(' ')} background>
        <Grid container style={{ justifyContent: 'center' }}>
          <Grid item md={4} xs={12} sm={5}>
            <Paper className={[classes.card, classes.padding10].join(' ')}>
              <Typography variant="title">Welcome {this.props.user.first_name},</Typography>
              <br />
              <Typography variant="body2">We are moving to a more secure authentication system with password-less access to all the accounts.</Typography>
              <br />
              <Typography variant="body2">Please <b>connect your social account</b> by clicking on any button below to proceed further.</Typography>
              <br />
              <hr /><br />
              {error}
              <div align="center">
                {buttons}
              </div>
              <br /><hr /><br />
              <Typography variant="body2">If you need any help please email us at <a href="mailto:support@anjalavsar.com">support@anjalavsar.com</a></Typography>
              <br />
              <Button onClick={this.logout} variant="outlined">Logout</Button>
            </Paper>
          </Grid>
        </Grid>
      </Layout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    user: state.auth.user,
    loading: state.auth.loading,
    hasError: state.auth.hasError,
    token: state.auth.token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doSocialLogin: (type, response, siteID, token) => dispatch(
      authActions.doSocialLogin(type, response, siteID, token, null, true),
    ),
    logout: token => dispatch(authActions.logout(token)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConnectSocialAuth));



// WEBPACK FOOTER //
// ./src/auth/containers/ConnectSocialAuth.js